import { MuiButton } from './MuiButton';
import { MuiCard } from './MuiCard';
import { MuiDataGrid } from './MuiDataGrid';
import { MuiDialog } from './MuiDialog';
import { MuiAppBar } from './MuiAppBar';
import { MuiDrawer } from './MuiDrawer';
import { MuiChip } from './MuiChip';
import { MuiInputLabel } from './MuiInputLabel';
import { MuiOutlinedInput } from './MuiOutlinedInput';
import { MuiTable } from './MuiTable';
import { MuiToggleButton } from './MuiToggleButton';

export const components = (mode) => ({
  ...MuiButton(mode),
  ...MuiCard(mode),
  ...MuiDataGrid(mode),
  ...MuiDialog(mode),
  ...MuiAppBar(mode),
  ...MuiDrawer(mode),
  ...MuiChip(mode),
  ...MuiInputLabel(mode),
  ...MuiOutlinedInput(mode),
  ...MuiTable(mode),
  ...MuiToggleButton(mode),
});